/**
 * @description Event types for keyboard
 * @author Stan Gletski
 */
export enum KeyEvent {
	KEYDOWN = 'keydown',
	KEYPRESS = 'keypress',
	KEYUP = 'keyup'
}